<template>
  <div>
    <div class="form-row">
      <app-checkbox
        :label="t('app-program-delivery-community-based')"
        @input="onInput($event, 'community')"
        :required="required"
        :description="t('app-program-delivery-community-based-description')"
      />
    </div>
    <div class="form-row">
      <app-checkbox
        :label="t('app-program-delivery-site-based')"
        @input="onInput($event, 'siteBased')"
        :required="required"
        :description="t('app-program-delivery-site-based-description')"
      />
    </div>
    <div class="form-row">
      <app-checkbox
        :label="t('app-program-delivery-e-mentoring')"
        @input="onInput($event, 'eMentoring')"
        :required="required"
        :description="t('app-program-delivery-e-mentoring-description')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import BaseMixin from "BaseMixin"

export default {
  mixins: [BaseMixin],

  props: ['search'],

  data() {
    return {
      required: false
    }
  },

  mounted() {
    this.$el.querySelectorAll("input[type='checkbox']").forEach((el) => el.checked = true)
    this.value = this.search.attributes.delivery
  },

  methods: {
    onInput(checked, key) {
      const index = this.value.indexOf(key)
      if(!checked && index != -1) this.value.splice(index, 1)
      else if(checked && index == -1) this.value.push(key)
      this.required = !this.value.length
    }
  }

}
</script>

<style lang="scss">
.program-delivery {
  .checked-content {
    padding-top: 10px;
    &:not(:last-child) {
      padding-bottom: 10px
    }
  }
}
</style>